import { API_URLS } from "../Constants/api.constants";
import api from "./api";
import { errorHandling } from "./error.handling";

const basePath = `${API_URLS.AUTH + "/v3"}/Users`;
const basePathVehicles = `${API_URLS.VEHICLE_V3_NEW}/vehicles/users/children`;

const getUsersConnected = async () => {
    try {
      let response = await api.get(basePath);
  
      let treated = errorHandling.handleResponse(
        response,
        "clientUserService.getUsersConnected"
      );
      if (treated) {
        return treated;
      }
      return null;
    } catch (error) {
      errorHandling.cathError(error, "clientUserService.getUsersConnected");
      return null;
    }
};

const create = async (payload) => {
  
      try {
        let response = await api.post(basePath, JSON.stringify(payload));
        let treated = errorHandling.handleResponse(
          response,
          "clientUserService.create"
        );
        if (treated) {
          return treated;
        }
        return null;
      } catch (error) {
        errorHandling.cathError(error, "clientUserService.create");
        return null;
      }
};

const update = async (payload) => {
  try {
    let response = await api.put(basePath, JSON.stringify(payload));
    let treated = errorHandling.handleResponse(
      response,
      "clientUserService.update"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "clientUserService.update");
    return null;
  }
};

const updateStatus = async (userTargetId, statusId) => {
  try {
    const payload = {
      UserTargetId: userTargetId,
      StatusId: statusId,
    };
    let response = await api.patch(basePath, JSON.stringify(payload));
    let treated = errorHandling.handleResponse(
      response,
      "clientUserService.updateStatus"
    );
    if (treated) {
      return treated;
    }
    return null;
  } catch (error) {
    errorHandling.cathError(error, "clientUserService.updateStatus");
    return null;
  }
};



const getUsersSons = async () => {
    try {
      let response = await api.get(`${basePath}/sons`);

      let treated = errorHandling.handleResponse(response, "clientUserService.getUsersSons");
      if (treated) {
        return treated;
      }
      return null;
    } catch (error) {
      errorHandling.cathError(error, "clientUserService.getUsersSons");
      return null;
    }
};

const getUsersByClient = async (clientId) => {
    const payload = {
        clientId: clientId
	};

    var url = `${basePath}/by-client?clientId=${clientId}`
    try {
      let response = await api.get(url, payload);
  
      let treated = errorHandling.handleResponse(response, "clientUserService.getUsersByClient");
      if (treated) {
        return treated;
      }
      return null;
    } catch (error) {
      errorHandling.cathError(error, "clientUserService.getUsersByClient");
      return null;
    }
};

const deleteUsersByClient = async (clientId) => {
  
  const url = `${basePath}?clientId=${clientId}&status=2`;

    try {
      let response = await api.delete(url);
  
      let treated = errorHandling.handleResponse(response, "clientUserService.deleteUsersByClient");
      if (treated) {
        return treated;
      }
      return null;
    } catch (error) {
      errorHandling.cathError(error, "clientUserService.deleteUsersByClient");
      return null;
    }
};

// const getUsersByClient = async (clientId) => {
//   try {
//     let response = await api.post(`/api/v3/Users/by-client`, JSON.stringify({ clientId }));

//     let treated = errorHandling.handleResponse(response, "clientUserService.getUsersByClient");
//     if (treated) {
//       return treated;
//     }
//     return null;
//   } catch (error) {
//     errorHandling.cathError(error, "clientUserService.getUsersByClient");
//     return null;
//   }
// };

const getUserLevels = async (payload) => {
    try {
      let response = await api.get(`${basePath}/levels`, payload);
  
      let treated = errorHandling.handleResponse(response, "clientUserService.getUserLevels");
      if (treated) {
        return treated;
      }
      return null;
    } catch (error) {
      errorHandling.cathError(error, "clientUserService.getUserLevels");
      return null;
    }
};

const changeUserPassword = async (payload) => {
    try {
      let response = await api.put(`${basePath}/password/change`, JSON.stringify(payload));
  
      let treated = errorHandling.handleResponse(response, "clientUserService.changeUserPassword");
      if (treated) {
        return treated;
      }
      return null;
    } catch (error) {
      errorHandling.cathError(error, "clientUserService.changeUserPassword");
      return null;
    }
  };

  const fetchUserSonVehicles = async (userSonId) => {
    try {
      let response = await api.get(`${basePathVehicles}/${userSonId}/vehicles`);

      let treated = errorHandling.handleResponse(
        response,
        "clientUserService.fetchUserSonVehicles"
      );
      if (treated) {
        return treated;
      }
      return null;
    } catch (error) {
      errorHandling.cathError(error, "clientUserService.fetchUserSonVehicles");
      return null;
    }
  };

  const setUserSonVehicleLink = async (payload) => {
    try {
      let response = await api.put(`${basePathVehicles}/vehicles`, JSON.stringify(payload));

      let treated = errorHandling.handleResponse(
        response,
        "clientUserService.setUserSonVehicleLink"
      );
      if (treated) {
        return treated;
      }
      return null;
    } catch (error) {
      errorHandling.cathError(error, "clientUserService.setUserSonVehicleLink");
      return null;
    }
  };

export const clientUserService = {
	  create,
    getUsersConnected,
    update,
    updateStatus,
    getUsersSons,
    getUsersByClient,
    getUserLevels,
    changeUserPassword,
      deleteUsersByClient,
      fetchUserSonVehicles,
      setUserSonVehicleLink
};
